import React from 'react';
import {Dialog, DialogActions, DialogContent, Button, TextField, Switch, Fab, Grid} from '@material-ui/core'



 

export default class AddUser extends React.Component {
    constructor(props) {
      super(props);
       this.state = {
     
         }
    }

     componentDidMount(){
  
    }

   
     render() { 
       return (
          <div>
               <Dialog 
                 className="pm-alert-dialog"
                disableEscapeKeyDown
                fullWidth={true}
                maxWidth='sm'
                 open={this.props.open}
                 onClose={this.props.dialogClose}>
                 <DialogActions >
                 <Fab  onClick={this.props.dialogClose} className="pm-round-button-dialog">
                                      <i className='material-icons pm-round-button-text-dialog'>close</i>
                            </Fab>
                 </DialogActions>
                 <h2 className='pm-dialog-alert-title'>{this.props.title}</h2>

                    <Grid  container  className="container pm-dialog-textfield-container" >
      
                            <Grid style={{textAlign:'center'}} item xs={12} sm={12} md={12} lg={12} xl={12} >
                                <TextField
                                    className="inputFocus loginTextField"
                                    id="with-placeholder"
                                    label={this.props.limba.settings.nume}
                                    margin="normal"
                                    value={this.props.strNumeUser || ''}
                                    onChange={this.props.numeChange}
                                />
                            </Grid>
                            <Grid style={{textAlign:'center'}} item xs={12} sm={12} md={12} lg={12} xl={12} >
                                <TextField
                                    
                                    className="inputFocus loginTextField"
                                    id="email-input"
                                    label={this.props.limba.settings.email}
                                    type="text"
                                    margin="normal"
                                    value={this.props.strEmail  || ""}
                                    onChange={this.props.emailChange}
                                />
                            </Grid>
                    </Grid>        

                 <DialogActions className="pm-dialog-bottom-buttons">
                          
                          <Button  variant="outlined" onClick={this.props.addUser} className='pm-save-button'>
                                      {this.props.limba.comune.add}
                          </Button>

                         
                          
                       
                      </DialogActions>
                       
                   
                 </Dialog>
         </div>
        );
       }
}